module.exports = __webpack_public_path__ + "static/img/BusinessArea.6f4d88c4.png";